/* eslint-disable react/no-array-index-key */
import React from "react"
import PropTypes from "prop-types"
import { Link, BrowserRouter as Router } from "react-router-dom"
import Icon from "../Icon"

const OrgPath = props => {
  const {
    path,
    path: { length },
    size
  } = props
  const last = length - 1

  const getLink = (i, leaf) => {
    return leaf.directHome
      ? "/engagement/vision2/insights"
      : `/engagement/vision2/insights/${leaf.level}/${leaf.id}`
  }

  const getBreadcrumbElement = (leaf, textSize, index) => {
    const largeStyle = index !== last ? "text-green-light" : "text-gray-dark"
    const smallStyle = index !== last ? "text-gray-light" : "text-gray-dark"

    return textSize === "large" ? (
      <h1 className={`text-truncate ${largeStyle} demo-tour-step-7`}>
        {leaf.name}
      </h1>
    ) : (
      <div className={`text-truncate ${smallStyle} caption-2-300`}>
        {leaf.name}
      </div>
    )
  }

  return (
    <div className="card-header border-bottom-0 pb-2 px-0 m-0 d-flex">
      {path.map((leaf, i) => (
        <div key={`${i}-${leaf.id}`} className="text-truncate d-flex">
          {i !== 0 && (
            <Icon
              name="breadcrumb"
              fill="#7B828A"
              className={size === "large" ? "mt-2" : ""}
              size={size}
            />
          )}
          {i !== last ? (
            <Router>
              <Link to={getLink(i, leaf)}>
                {getBreadcrumbElement(leaf, size, i)}
              </Link>
            </Router>
          ) : (
            getBreadcrumbElement(leaf, size, i)
          )}
        </div>
      ))}
    </div>
  )
}

export default OrgPath

OrgPath.propTypes = {
  path: PropTypes.arrayOf(
    PropTypes.shape({
      directHome: PropTypes.bool,
      id: PropTypes.string,
      level: PropTypes.string,
      name: PropTypes.string
    })
  ).isRequired,
  size: PropTypes.string.isRequired
}
